// extracted by mini-css-extract-plugin
module.exports = {"cls1":"SideNav-MenuButton-module--cls1--4Fx9F","cls2":"SideNav-MenuButton-module--cls2--3Tgj0 SideNav-MenuButton-module--cls1--4Fx9F p-0 d-md-none ml-3"};